export const appConf = {
  dateDefaultFormat: "MM/DD/YYYY",
  isDevelopmentMode: (!process.env.NODE_ENV || process.env.NODE_ENV === 'development')
};



// WEBPACK FOOTER //
// ./src/modules/Setup/appConfig/app.config.js